/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DisplayedDimension { 
    displayAttribute: string;
    displayAttributeOrDefault?: string;
    displayedElements?: Array<{ [key: string]: string; }>;
    filterAttribute?: string;
    filterAttributeOrDefault?: string;
    id: string;
    selectionMode?: DisplayedDimension.SelectionModeEnum;
    sortDirection?: DisplayedDimension.SortDirectionEnum;
    subsetId?: string;
    valueFilter?: Array<string>;
    withoutDisplayAttribute?: boolean;
}
export namespace DisplayedDimension {
    export type SelectionModeEnum = 'ALL' | 'INCLUDE' | 'EXCLUDE';
    export const SelectionModeEnum = {
        All: 'ALL' as SelectionModeEnum,
        Include: 'INCLUDE' as SelectionModeEnum,
        Exclude: 'EXCLUDE' as SelectionModeEnum
    };
    export type SortDirectionEnum = 'DESC' | 'ASC' | 'DESC_INDEX' | 'ASC_INDEX' | 'SOURCE_ORDER';
    export const SortDirectionEnum = {
        Desc: 'DESC' as SortDirectionEnum,
        Asc: 'ASC' as SortDirectionEnum,
        DescIndex: 'DESC_INDEX' as SortDirectionEnum,
        AscIndex: 'ASC_INDEX' as SortDirectionEnum,
        SourceOrder: 'SOURCE_ORDER' as SortDirectionEnum
    };
}


